import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from '../../actions/userActions';
import * as types from '../../constants/actionTypes';
import Drawer from '../Common/Drawer/Drawer';
import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';
import Notification from '../Common/Notification';
import MultiSelectBox from '../Common/MultiSelectBox/MultiSelectBox';
import InputText from '../Common/InputText';
import './UserBulkLocationSearchDrawer.scss';

export class UserBulkLocationSearchDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            isLoading: false,
            search: '',
            areas: [],
            brands: [],
            continents: [],
            countries: [],
            locationTypes: [],
            managementCompanies: [],
            regions: [],
            filterValues: {
                areas: '',
                brands: '',
                continents: '',
                countries: '',
                locationTypes: '',
                managementCompanies: '',
                regions: ''
            },
            fullName: '',
            availableLocations: [],
            selectedLocations: []
        };
    }

    async componentDidMount() {
        this.loadFilters();
    }

    loadFilters = async () => {
        try {
            this.setState({ isLoading: true });
            const response = await this.props.actions.loadUserBulkLocationSearchFilters(this.props.subscriptionId);
            if (response.type === types.LOAD_USER_BULK_LOCATION_FILTERS_SUCCESS) {
                this.setState({
                    areas: response.payload.areas,
                    brands: response.payload.brands,
                    continents: response.payload.continents,
                    countries: response.payload.countries,
                    locationTypes: response.payload.locationTypes,
                    managementCompanies: response.payload.managementCompanies,
                    regions: response.payload.regions,
                });
            } else if (response.type === types.LOAD_USER_BULK_LOCATION_FILTERS_FAILURE) {
                Notification("error", "An Error Occurred", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    onFormChange = (e) => {
        this.setState({ search: e.target.value });
    }

    keyUpFilter = (e) => {
        if (e.keyCode == 13) {
            this.onSearch();
        }
    }

    onMultiSelectChange = (csv, name) => {
        this.setState({
            filterValues: {
                ...this.state.filterValues,
                [name]: csv
            }
        })
    }

    //we want the user to have the option of searching by a comma-delimited, space-delimited, or newline delimited list
    searchTermsToArray = (terms) => {

        if (!terms) {
            return [];
        }

        if (terms.includes(',')) {
            return terms.split(',')
        }

        //if they copy/pasted from excel it will carry over newlines that need to be replaced with spaces
        terms = terms.replace(/\n/g, ' ');
        return terms.split(' ');
    }

    onSearch = async () => {
        try {
            this.setState({ isLoading: true });
            const filterValues = this.parseLocationSearchAttributes({});
            
            const searchTerms = this.searchTermsToArray(this.state.search);

            const request = {
                subscriptionId: this.props.subscriptionId,
                userId: this.props.userId,
                searchTerms: searchTerms,
                ...filterValues
            };
            const response = await this.props.actions.searchUserLocations(request);
            if (response.type === types.SEARCH_USER_LOCATION_FILTERS_SUCCESS) {
                let availableLocations = response.payload.locations;
                availableLocations = availableLocations.filter(item => {
                    const selectedIndex = this.props.selectedLocations.findIndex(x=> x.id === item.id);
                    return selectedIndex < 0; // remove all currently selected locations from the list of available locations
                });
                
                this.setState({
                    availableLocations: availableLocations,
                });
            } else if (response.type === types.SEARCH_USER_LOCATION_FILTERS_FAILURE) {
                Notification("error", "An Error Occurred", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    parseLocationSearchAttributes = (filterValues) => {
        if (this.state.filterValues.areas.trim().length > 0) {
            filterValues.areaIds = this.state.filterValues.areas.split(',');
        }

        if (this.state.filterValues.brands.trim().length > 0) {
            filterValues.brandIds = this.state.filterValues.brands.split(',');
        }

        if (this.state.filterValues.continents.trim().length > 0) {
            filterValues.continentIds = this.state.filterValues.continents.split(',');
        }

        if (this.state.filterValues.countries.trim().length > 0) {
            filterValues.countryIds = this.state.filterValues.countries.split(',');
        }

        if (this.state.filterValues.locationTypes.trim().length > 0) {
            filterValues.locationTypeIds = this.state.filterValues.locationTypes.split(',');
        }

        if (this.state.filterValues.managementCompanies.trim().length > 0) {
            filterValues.managementCompanyIds = this.state.filterValues.managementCompanies.split(',');
        }

        if (this.state.filterValues.regions.trim().length > 0) {
            filterValues.regionIds = this.state.filterValues.regions.split(',');
        }

        if (this.state.filterValues.areas.trim().length > 0) {
            filterValues.areaIds = this.state.filterValues.areas.split(',');
        }

        return filterValues;
    }

    onCancel = () => {
        this.setState({ isFormValid: true, drawerOpen: false });
        this.props.onCancel();
    }

    onAddSelected = async () => {
        this.props.onComplete(this.state.selectedLocations);
    }

    onSelectChange = (e) => {
        const options = e.target.options;
        let selected = [];
        for (var i = 0; i < options.length; i++) {
            if (options[i].selected) {
                const value = options[i].value;
                const location = this.state.availableLocations.find(x => x.id.toString() === value);
                selected.push(location);
            }
        }
        this.setState({ selectedLocations: selected });
    }

    render() {
        return (
            <Drawer isWide={true} title="Bulk Location Search"
                onSaveClick={this.onAddSelected}
                saveText='Add Selected'
                onCancelClick={this.onCancel}
                menuButtons={this.props.menuButtons}>
                <LoadingIndicator isLoading={this.state.isLoading}>
                    <div className="user-bulk-location-search-form">
                        <h4>{this.props.userFullName}</h4>
                        <div className="row">
                            <div className="col search-field">
                                <InputText name="search" label="Search" placeholder="Search" type="text" value={this.state.search} onChange={this.onFormChange} onKeyUp={this.keyUpFilter} />
                                <button className="pacer61-secondary-btn ms-2" name="go" onClick={this.onSearch}>Go</button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <MultiSelectBox name="brands" label="Brand" idField="id" valueField="name"
                                    options={this.state.brands}
                                    selectedValues={this.state.filterValues.brands}
                                    onChange={this.onMultiSelectChange}
                                    isMulti={true}
                                />
                                <MultiSelectBox name="continents" label="Continent" idField="id" valueField="name"
                                    options={this.state.continents}
                                    selectedValues={this.state.filterValues.continents}
                                    onChange={this.onMultiSelectChange}
                                    isMulti={true}
                                />
                                <MultiSelectBox name="regions" label="Region" idField="id" valueField="name"
                                    options={this.state.regions}
                                    selectedValues={this.state.filterValues.regions}
                                    onChange={this.onMultiSelectChange}
                                    isMulti={true}
                                />
                            </div>
                            <div className="col-md-6">
                                <MultiSelectBox name="areas" label="Area" idField="id" valueField="name"
                                    options={this.state.areas}
                                    selectedValues={this.state.filterValues.areas}
                                    onChange={this.onMultiSelectChange}
                                    isMulti={true}
                                />
                                <MultiSelectBox name="locationTypes" label="Type" idField="id" valueField="name"
                                    options={this.state.locationTypes}
                                    selectedValues={this.state.filterValues.locationTypes}
                                    onChange={this.onMultiSelectChange}
                                    isMulti={true}
                                />
                                <MultiSelectBox name="managementCompanies" label="Management Company" idField="id" valueField="name"
                                    options={this.state.managementCompanies}
                                    selectedValues={this.state.filterValues.managementCompanies}
                                    onChange={this.onMultiSelectChange}
                                    isMulti={true}
                                />
                                <MultiSelectBox name="countries" label="Country" idField="id" valueField="name"
                                    options={this.state.countries}
                                    selectedValues={this.state.filterValues.countries}
                                    onChange={this.onMultiSelectChange}
                                    isMulti={true}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <span className="has-float-label">
                                    <select id="locationList" className="form-control mt-3" multiple size="8" defaultValue={[]} onChange={this.onSelectChange}>
                                        {
                                            this.state.availableLocations.map(opt => <option key={opt.id} value={opt.id}>{opt.name}</option>)
                                        }
                                    </select>
                                    <label htmlFor="locationList">Available Locations</label>
                                </span>
                            </div>
                        </div>
                    </div>
                </LoadingIndicator>
            </Drawer >
        )
    }
}

UserBulkLocationSearchDrawer.propTypes = {
    subscriptionId: PropTypes.string.isRequired,
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    actions: PropTypes.object.isRequired,
    userId: PropTypes.string.isRequired,
    userFullName: PropTypes.string.isRequired,
    menuButtons: PropTypes.array.isRequired,
    selectedLocations: PropTypes.array.isRequired
};

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),
    };
}

export default connect(null, mapDispatchToProps)(UserBulkLocationSearchDrawer);
